module.exports = __webpack_public_path__ + "img/vallone-exalt-tooltips-configurator-01.60f95307.jpg";